import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-nav-item-list-items, [glxyNavItemListItems]',
  standalone: false,
})
export class GalaxyNavItemListItemsDirective {
  @HostBinding('class') class = 'glxy-nav-item-list-items';
}
